// 发起第三方支付
// http://api.umucdn.cn/project/216/interface/api/3012
import { fetchData } from '@umu/umu-fetch';
import { PAYMENT_CLIENT_MODE, PAYMENT_MODE_CHANNEL } from '@umu/umu-types';
import Api from '../../path';

export interface IInput {
    pay_mode: string; // todo 1-alipay,2-paypal,3-weixin
    out_trade_no: string; // 商品唯一订单号, U202003281933003144614
    return_url: string; // 支付完成后跳转地址
    client_mode?: PAYMENT_CLIENT_MODE;
    wx_channel?: PAYMENT_MODE_CHANNEL;
}

export interface IOutput {
    pay_mode: string; // todo 1-alipay,2-paypal,3-weixin
    html: string;
    payment_qr?: string;
    payment?: IPlainData; // 有些支付渠道会返回支付的相关数据，比如wxin会返回一些openid或者验证信息
}

export const createPay = (data: IInput, options?: { silent?: boolean }): Promise<IResponse<IOutput>> => {
    return fetchData(Api.PAYMENT_CREATE_PAY, data, { silent: options?.silent || false }).then(
        (res: IResponse<IOutput>) => res,
    );
};
